import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Link } from 'react-router-dom';
import logo from 'assets/img/illustrations/falcon.png';
import { ProjectContext } from 'contexts/ProjectContext';
import { BRAND_NAME } from 'helpers/brand';

const Logo = ({ at, width, className, textClass, ...rest }) => {
  const projectContext = useContext(ProjectContext);
  const currentProject = projectContext?.currentProject;
  const projectData = currentProject?.project_data || {};
  const logoSrc =
    projectData.icon && (projectData.icon.startsWith('http') || projectData.icon.startsWith('/'))
      ? projectData.icon
      : logo;
  // Fallback на нейтральный BRAND_NAME: на auth-страницах ProjectProvider
  // отсутствует (currentProject = undefined) — не должно светиться имя
  // конкретного проекта (раньше был хардкод «TeslaPay»).
  const projectName = currentProject?.name || BRAND_NAME;

  return (
    <Link
      to="/"
      className={classNames(
        'text-decoration-none',
        { 'navbar-brand text-left': at === 'navbar-vertical' },
        { 'navbar-brand text-left': at === 'navbar-top' }
      )}
      {...rest}
    >
      <div
        className={classNames(
          'd-flex',
          {
            'align-items-center py-3': at === 'navbar-vertical',
            'align-items-center': at === 'navbar-top',
            'flex-center fw-bolder fs-4 mb-4': at === 'auth'
          },
          className
        )}
      >
        <img className="me-2 flex-shrink-0" src={logoSrc} alt="Logo" width={40} height={40} style={{ objectFit: 'contain' }} />
        <span className={classNames('font-sans-serif', textClass)}>
          {projectName}
        </span>
      </div>
    </Link>
  );
};

Logo.propTypes = {
  at: PropTypes.oneOf(['navbar-vertical', 'navbar-top', 'auth']),
  width: PropTypes.number,
  className: PropTypes.string,
  textClass: PropTypes.string
};

Logo.defaultProps = { at: 'auth', width: 58 };

export default Logo;
